import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed } from 'vue'
import { ADOType } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

0
import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'AdosBrief',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  ados: {
    type: Array as () => { id: string; adoType: number; name: string }[],
    required: true,
  },
  colse: {
    type: Function,
    Required: false,
  },
  objid: {
    type: String,
    Required: false,
  },
},
  setup(__props) {

const props = __props

const { tl } = useI18nTl('Operation')


const objid = computed(() => {
  return props.objid
})

const ados = computed(() => {
  return props.ados
})
const handleClose = computed(() => {
  return (
    props.colse ||
    function (objid: string, ado: any) {
      console.log('Default close handler executed', objid, ado)
    }
  )
})

const adoDesc = (adotype: number): string => {
  switch (adotype) {
    case ADOType.ADOT_OPERATOR:
      return tl('operator')
    case ADOType.ADOT_STATION:
      return tl('station')
    case ADOType.ADOT_EVSE:
      return tl('evse')
    case ADOType.ADOT_USER:
      return tl('user')
    case ADOType.ADOT_GROUP:
      return tl('group')
    case ADOType.ADOT_BRAND:
      return tl('brand')
  }
  return String('Unknown')
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ados), (ado) => {
    return (_openBlock(), _createElementBlock("div", {
      key: ado.id,
      class: "tariff-row"
    }, [
      _createVNode(_component_el_tooltip, { placement: "top" }, {
        content: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(adoDesc(ado.adoType)), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_tag, {
            closable: "",
            onClose: () => _unref(handleClose)(_unref(objid), ado)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(ado.name), 1)
            ]),
            _: 2
          }, 1032, ["onClose"])
        ]),
        _: 2
      }, 1024)
    ]))
  }), 128))
}
}

})